function optIn(bundle, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/optIn/${bundle}`;
  return apiClient.post(route);
}

function optOut(bundle, currentLocation, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/optIn/${bundle}`;
  return apiClient.delete(route, { currentLocation });
}

export default {
  optIn,
  optOut
};



// WEBPACK FOOTER //
// ./app/api/OptInApi.js